import React from "react"

export default function NotFoundPage() {
  return (
    <div>
      <p>404: Nothing to see here.</p>
    </div>
  );
}
